export default "__VITE_ASSET__Bm$XTSpb__"